import { features } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-3">
          为什么选择80s电影网
        </h2>
        <p className="text-foreground-400 text-sm text-center mb-10 max-w-lg mx-auto">
          三大核心优势，重新定义免费在线观影体验
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 border border-background-200/30 rounded-xl p-6 md:p-8 hover:border-primary-500/30 transition-all duration-300 group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 mb-5 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-100 mb-3 font-heading">
                {item.title}
              </h3>
              <p className="text-foreground-400 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}